import { render, staticRenderFns } from "./Balances.vue?vue&type=template&id=556a1a7a&scoped=true"
import script from "./Balances.vue?vue&type=script&lang=js"
export * from "./Balances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a1a7a",
  null
  
)

export default component.exports